export const removeNumbers = (str: string) => str.replace(/[0-9]/g, '');
